import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ['confirmation-dialog.component.css']
})
export class ConfirmationDialog {
  message: string = "Are you sure?"
  confirmButtonText = "OK"
  cancelButtonText = "Cancel"
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ConfirmationDialog>) {
    if (data) {
      this.message = data.message || this.message;
      // if (data.buttonText) {
      //   this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
      //   this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      // }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
}